import { interfaces } from 'inversify'
import { EntityListStore } from '../list'

export const fetchOnActivation = <E extends EntityListStore>(context: interfaces.Context, listStore: E) => {
    // cannot await in onActivation
    listStore.fetch()
    return listStore
}
